import React from "react";
import styled from "styled-components";
import { Modal } from "antd";
import iconClose from "../../../../../assets/images/Event-2025/icon-btn-close-popup.png";
import bgSuper from "../../../../../assets/images/Event-2025/popup-super-box.png";
import bgNomal from "../../../../../assets/images/Event-2025/popup-nomal-box.png";

export default function PopupChristmasBox({ open, setOpen = () => {}, idBox }) {
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <StyleModal
      centered
      visible={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      getContainer={false}
      footer={false}
      //   getContainer={isGetContainer ? "" : false}
    >
      <div className="position-relative">
        <img
          src={idBox === 2 ? bgSuper : bgNomal}
          alt=""
          className="bg-popup"
        />
        <img
          src={iconClose}
          alt=""
          className="icon-close"
          onClick={handleCancel}
        />
      </div>
    </StyleModal>
  );
}

const StyleModal = styled(Modal)`
  .icon-main-popup img {
    position: absolute;
    bottom: 0;
    z-index: 10;
    pointer-events: none;
  }

  .icon-main-popup {
    .icon-ng,
    .icon-th {
      bottom: 140px;
    }

    .icon-ng {
      left: 0;
    }

    .icon-th {
      right: -60px;
    }
  }

  .icon-main-popup .icon-error {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }

  .bg-popup {
    border-radius: 30px;
    overflow: hidden;
    /* height: 100%; */
    width: 100%;
  }

  .body-popup {
    border-radius: 30px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .icon-close {
    position: absolute;
    right: 48px;
    z-index: 9;
    top: 42px;
    width: 42px;
    cursor: pointer;
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: inherit !important;
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-body {
    text-align: center;
    display: flex;
    justify-content: center;
    padding-top: 30px;
  }

  .ant-modal-close {
    right: 40px !important;

    svg {
      color: white;
    }
  }

  @media (min-width: 992px) {
    .icon-close,
    .container-action-main {
      &:hover {
        scale: 1.05;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
    .header-container-popup {
      max-width: calc(100% + 10px);
      width: calc(100% + 10px);
    }

    .icon-close {
      width: 36px;
      right: 38px;
    }

    .content-header {
      top: 20px;
    }

    .main-content {
      padding-top: 60px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 16px;
      line-height: 1.4;
      font-weight: 500;
    }

    .icon-ng {
      width: 120px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 130px;
    }

    .icon-main-popup .icon-error {
      width: 160px;
    }

    .content-footer {
      padding-bottom: 25px;
      font-size: 13px;
    }

    .icon-error-full {
      width: 180px !important;
    }
  }

  @media (max-width: 430px) {
    .content-header {
      top: 16px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 110px;
    }

    .icon-ng {
      width: 100px;
    }

    .icon-th {
      height: 160px;
    }
  }
`;
